import { LocationQuestionConfig } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { ControlledCheckboxItem } from '../../../../../components/forms';
import {
  RoutineQuestionAdminForm,
  RoutineQuestionAdminFormProps,
} from '../types';
import { themedStyleSheet } from '../../../../../themes/themedStyleSheet';

export const LocationQuestionAdminForm: RoutineQuestionAdminForm<
  LocationQuestionConfig
> = (props: RoutineQuestionAdminFormProps<LocationQuestionConfig>) => {
  const { t } = useTranslation();
  const prefix = props.indexPrefix ? `${props.indexPrefix}.` : '';
  const includeMemoFieldName = `${prefix}includeMemo`;

  props.control.register(includeMemoFieldName, {
    value: props.config.includeMemo ?? false,
  });

  return (
    <ControlledCheckboxItem
      control={props.control}
      name={includeMemoFieldName}
      label={t('routines.workflow.admin.question.location.includeMemo')}
      position="trailing"
      style={styles.container}
      labelStyle={styles.label}
    />
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    paddingHorizontal: 0,
  },
  label: {
    fontSize: 16,
    lineHeight: 16,
    color: role.textStrong,
    marginBottom: 10,
    fontWeight: '700',
  },
}));
